module.exports = __webpack_public_path__ + "img/Avatar-93.4ecb784b.svg";